import { connect } from 'react-redux';
import { togglePopup } from '../../redux/actions/app.action';
import { DispatchType } from '../../redux/types';
import Popup from './Popup';
import { PropsType } from './types';

const mapState = ({ app }: PropsType) => ({
  isPopupOpen: app.isPopupOpen,
  modalChildren: app.modalChildren,
   onModalDismiss: app.onModalDismiss,
   popupSize: app.popupSize,
   closeIcon: app.closeIcon,

});

const mapDispatchProps = (dispatch: DispatchType) => ({
  togglePopup: (data: {isPopupOpen: boolean}) => togglePopup(data)(dispatch),
});

export default connect(mapState, mapDispatchProps)(Popup);
